import request from '../network';

export const getPetLifeStageListApi = (params?: Record<string, any>) => {
  return request({
    url: '/member/royalcanin/admin/petLifeStage/list',
    method: 'GET',
    params,
  });
};

export const getPetLifeStageDetailApi = (id: number | string) => {
  return request({
    url: `/member/royalcanin/admin/petLifeStage/${id}`,
    method: 'GET',
  });
};

export const updatePetLifeStageApi = (data: Record<string, any>) => {
  return request({
    url: '/member/royalcanin/admin/petLifeStage',
    method: 'PUT',
    data,
  });
};

export const createPetLifeStageApi = (data: Record<string, any>) => {
  return request({
    url: '/member/royalcanin/admin/petLifeStage',
    method: 'POST',
    data,
  });
};

export const deletePetLifeStageApi = (id: number | string) => {
  return request({
    url: `/member/royalcanin/admin/petLifeStage/${id}`,
    method: 'DELETE',
  });
};

export const getLifeStageByBodySizeApi = (data: { bodySize: string; petType: string }) => {
  return request({
    url: '/member/royalcanin/admin/petLifeStage/getListByBodySize',
    method: 'POST',
    data,
  });
};
